module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-03-8bd215787dea346d9994394a9fe5dc75.png";